import targeting from './targeting-factory';
export var evaluateTargeting = targeting.evaluateTargeting;
//# sourceMappingURL=index.js.map